const EatsTransactionTypes: any = {
  ALL: {
    description: 'All eat transactions',
    value: 'KASASA_EATS_REWARD',
  },
  GROCERY: {
    description: 'Grocery purchases only',
    value: 'GROCERY',
  },
  MEAL_DELIVERY: {
    description: 'Meal delivery purchases only',
    value: 'MEAL_DELIVERY',
  },
};

export default EatsTransactionTypes;
